export default {
	start: {
		title: "Ai Platform",
		tips: "Turn Scrolling into Earning! Cash Out Daily with Just a Tap - Your Phone, Your Money Machine!"
	},
	login: {
		tips: "Don't have an account?",
		Signup: "Sign up",
		logIn: "Sign in",
		Remember: "Remember me",
		form: {
			label: ["Username/Phone", "Password"]
		},
		forgotPassword: "Forgot Password?",
		contactSupport: "Contact Support",
		title: "Create account",
		content: ["Need an account?", "Create account here"]
	},
	register: {
		form: {
			label: [
				"Username",
				"Phone",
				"Transaction Password",
				"Login Password",
				"Confirm Login Password",
				"Gender",
				"Invite Code",
				"Email",
				"Verification Code"
			],
			rule: {
				Username: "Username length must be 4-10 characters",
				Email: "Please enter your vaild email",

				Phone: "Phone length cannot be less than 4 digits",
				ConfirmLoginPassword: "Inconsistent passwords",
				TradingPassword: "Transaction password length cannot be less than 6 digits",
				LoginPassword: "Login password length cannot be less than 6 digits"
			}
		},
		sendMsg: "Code sent! Please check your messages.",
		agree: ["I agree to {0}", "Privacy Notice,MSA", "and", "Terms of Service"],
		content: [
			"Create your free account",
			"Already have an account?",
			"Login here",
			"Create account",
			"By continuing you agree to our"
		]
	}
};
